import { useQuery } from '@tanstack/react-query';
import { IGetAdmins, IGetAdminsResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAdmins = async (params: IGetAdmins) => {
  const res = await apiManager.get<IGetAdminsResponse>(
    "/admin/admins/all",
    params
  );

  return res;
};



export const useGetAdmins = (params: IGetAdmins) =>
  useQuery({
    queryKey: ["get_admins", params],
    queryFn: async (): Promise<IGetAdminsResponse> => {
      const res = await apiClient.get(ENDPOINTS.ADMIN.GET_ALL, { params });
      return res.data;
    },
  });